import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { ModalAllder } from "./ModalAllder";
import { Button, Form } from "react-bootstrap";
import InvoicePaymentModal from "./InvoicePaymentModal";
export default function InvoiceModalGroup(param) {
    var setFieldValue = param.setFieldValue, handleChange = param.handleChange, modalInvoiceModalState = param.modalInvoiceModalState, values = param.values;
    var modalConfirmCancel = modalInvoiceModalState.modalConfirmCancel, setModalConfirmCancel = modalInvoiceModalState.setModalConfirmCancel, modalSuccess = modalInvoiceModalState.modalSuccess, setModalSuccess = modalInvoiceModalState.setModalSuccess, modalSaveSuccess = modalInvoiceModalState.modalSaveSuccess, setModalSaveSuccess = modalInvoiceModalState.setModalSaveSuccess, modalNotApprove = modalInvoiceModalState.modalNotApprove, setModalNotApprove = modalInvoiceModalState.setModalNotApprove, modalAlert = modalInvoiceModalState.modalAlert, setModalAlert = modalInvoiceModalState.setModalAlert, modalSubmitted = modalInvoiceModalState.modalSubmitted, setModalSubmitted = modalInvoiceModalState.setModalSubmitted;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2 flex justify-center",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalAlert,
                setModal: setModalAlert,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-center pt-4",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: [
                            "กรุณาเพิ่มรายการสินค้า ",
                            /*#__PURE__*/ _jsx("br", {}),
                            " อย่างน้อย 1 รายการ"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center pb-4 pt-5 ",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-auto",
                            onClick: function() {
                                return setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยืนยัน"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalNotApprove,
                setModal: setModalNotApprove,
                htitle: "ยืนยันการไม่อนุมัติ",
                hbtn: false,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "py-4",
                    children: [
                        /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-3 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลไม่อนุมัติ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 3,
                                    name: "not_approve_reason",
                                    onChange: handleChange,
                                    isInvalid: !values.not_approve_reason,
                                    value: values.not_approve_reason
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-2  tc-10",
                                    children: "การดำเนินการ"
                                }),
                                [
                                    "radio"
                                ].map(function(type) {
                                    return /*#__PURE__*/ _jsx("div", {
                                        className: "mb-3",
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            inline: true,
                                            label: "ยกเลิกเอกสาร",
                                            name: "dim_mst_invoice_status_id",
                                            onChange: function() {
                                                return setFieldValue("dim_mst_invoice_status_id", 5);
                                            },
                                            type: type,
                                            id: "invoice$1rs-".concat(type, "-20"),
                                            className: "form-check-st-2 tc-7"
                                        })
                                    }, "inline-".concat(type));
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center pb-4 pt-5 ",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 ms-auto me-3 btn",
                                    onClick: function() {
                                        return setModalNotApprove(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: false
                                            });
                                        });
                                    },
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalConfirmCancel,
                setModal: setModalConfirmCancel,
                htitle: "ยืนยันการยกเลิก",
                hbtn: false,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "py-4",
                    children: [
                        /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-3 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการยกเลิก ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 5,
                                    name: "not_approve_reason",
                                    onChange: handleChange,
                                    isInvalid: !values.not_approve_reason,
                                    value: values.not_approve_reason
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center pb-4 pt-4 ",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 ms-auto me-3 btn",
                                    onClick: function() {
                                        return setModalConfirmCancel(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: false
                                            });
                                        });
                                    },
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function() {
                                        // e.preventDefault();
                                        setFieldValue("dim_mst_invoice_status_id", 6);
                                    },
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSubmitted,
                setModal: setModalSubmitted,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2 flex justify-center",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "aspect-square w-[59px]",
                            src: "/images/icon-alert-warn-orange.png"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "tc-16 text-center fw-bold fs-18",
                        children: [
                            "ระบบจะทำการส่งเอกสารไปยังระบบภาษีขาย",
                            /*#__PURE__*/ _jsx("br", {}),
                            "คุณจะไม่สามารถแก้ไขและยกเลิกเอกสารได้อีก"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-end gap-[10px] pt-[50px]",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                onClick: function() {
                                    return setModalSubmitted(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: false
                                        });
                                    });
                                },
                                className: "btn-st-6 me-3 btn",
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "submit",
                                onClick: function() {
                                    return setFieldValue("is_submitted", true);
                                },
                                className: "btn-st-4 me-3 btn",
                                children: "ยืนยัน"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(InvoicePaymentModal, {})
        ]
    });
}
